import React, { useEffect, useState } from 'react';
import { useApi } from '../../hooks/useApi';
import Spinner from '../../components/Spinner';

type NoteArticle = {
  title: string;
  url: string;
  published_at: string | null;
  thumbnail_url: string | null;
};

const NoteArticles = () => {
  const [articles, setArticles] = useState<NoteArticle[] | null>(null);
  const { get, loading } = useApi();

  useEffect(() => {
    get({
      endpoint: '/api/v1/note_articles',
      skipAuth: true,
      onSuccess: (res) => {
        setArticles(res?.data || []);
      },
      onError: (err) => {
        console.error(err.message);
        setArticles([]);
      },
    });
  }, [get]);

  // Hide section only after fetch completes with no results
  if (!loading && articles !== null && articles.length === 0) return null;

  return (
    <section className="note_articles">
      <div className="inner">
        <h2 className="sec_title">公式 note 最新記事</h2>
        {loading ? (
          <Spinner centered />
        ) : (
          <ul className="cards">
            {(articles ?? []).map((article) => (
              <li key={article.url}>
                <a href={article.url} target="_blank" rel="noopener noreferrer">
                  <div className="thumb">
                    {article.thumbnail_url && (
                      <img src={article.thumbnail_url} alt={article.title} />
                    )}
                  </div>
                  {article.published_at && (
                    <time dateTime={article.published_at}>
                      {article.published_at.slice(0, 10).replace(/-/g, '.')}
                    </time>
                  )}
                  <h3>{article.title}</h3>
                </a>
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
};

export default NoteArticles;
